import type { EditorSection, FieldSpec } from './types';

const C056 = 'FIToFIPmtCxlReq';
const C029 = 'RsltnOfInvstgtn';

export const CAMT056_FIELDS: FieldSpec[] = [
  {
    key: 'xmlns',
    xmlSelectors: ['Document@xmlns'],
    labelKey: 'try.fieldXmlns',
    defKey: 'try.defXmlns',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'assignmentId',
    xmlSelectors: [`${C056}/Assgnmt/Id`, `${C029}/Assgnmt/Id`],
    labelKey: 'try.camt.fieldAssignmentId',
    defKey: 'try.camt.defAssignmentId',
    kind: 'text',
  },
  {
    key: 'caseId',
    xmlSelectors: [`${C056}/Case/Id`, `${C029}/RslvdCase/Id`],
    labelKey: 'try.camt.fieldCaseId',
    defKey: 'try.camt.defCaseId',
    kind: 'text',
  },
  {
    key: 'createdAt',
    xmlSelectors: [`${C056}/Assgnmt/CreDtTm`, `${C029}/Assgnmt/CreDtTm`],
    labelKey: 'try.fieldCreatedAt',
    defKey: 'try.defCreatedAt',
    kind: 'datetime',
  },
  {
    key: 'assignorBic',
    xmlSelectors: [`${C056}/Assgnmt/Assgnr/Agt/FinInstnId/BICFI`, `${C029}/Assgnmt/Assgne/Agt/FinInstnId/BICFI`],
    labelKey: 'try.camt.fieldAssignorBic',
    defKey: 'try.camt.defAssignorBic',
    kind: 'text',
  },
  {
    key: 'assigneeBic',
    xmlSelectors: [`${C056}/Assgnmt/Assgne/Agt/FinInstnId/BICFI`, `${C029}/Assgnmt/Assgnr/Agt/FinInstnId/BICFI`],
    labelKey: 'try.camt.fieldAssigneeBic',
    defKey: 'try.camt.defAssigneeBic',
    kind: 'text',
  },
  {
    key: 'orgnlMsgId',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/OrgnlGrpInf/OrgnlMsgId`],
    labelKey: 'try.camt.fieldOrgnlMsgId',
    defKey: 'try.camt.defOrgnlMsgId',
    kind: 'text',
  },
  {
    key: 'orgnlMsgNmId',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/OrgnlGrpInf/OrgnlMsgNmId`],
    labelKey: 'try.fieldOrgnlMsgNmId',
    defKey: 'try.camt.defOrgnlMsgNmId',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'orgnlEndToEndId',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/OrgnlEndToEndId`, `${C029}/CxlDtls/TxInfAndSts/OrgnlEndToEndId`],
    labelKey: 'try.fieldEndToEndId',
    defKey: 'try.defEndToEndId',
    kind: 'text',
  },
  {
    key: 'orgnlTxId',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/OrgnlTxId`],
    labelKey: 'try.fieldTxId',
    defKey: 'try.defTxId',
    kind: 'text',
  },
  {
    key: 'orgnlAmount',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/OrgnlIntrBkSttlmAmt`],
    labelKey: 'try.fieldAmount',
    defKey: 'try.camt.defOrgnlAmount',
    kind: 'text',
  },
  {
    key: 'orgnlCurrency',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/OrgnlIntrBkSttlmAmt@Ccy`],
    labelKey: 'try.fieldCurrency',
    defKey: 'try.defCurrency',
    kind: 'text',
  },
  {
    key: 'orgnlSettlementDate',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/OrgnlIntrBkSttlmDt`],
    labelKey: 'try.fieldSettlementDate',
    defKey: 'try.defSettlementDate',
    kind: 'date',
  },
  {
    key: 'cxlId',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/CxlId`],
    labelKey: 'try.camt.fieldCxlId',
    defKey: 'try.camt.defCxlId',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'cxlReason',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/CxlRsnInf/Rsn/Cd`],
    labelKey: 'try.camt.fieldCxlReason',
    defKey: 'try.camt.defCxlReason',
    kind: 'select',
    options: ['DUPL', 'FRAD', 'TECH', 'CUST', 'AM09'],
  },
  {
    key: 'addtlInf',
    xmlSelectors: [`${C056}/Undrlyg/TxInf/CxlRsnInf/AddtlInf`],
    labelKey: 'try.fieldAddtlInf',
    defKey: 'try.camt.defAddtlInf',
    kind: 'text',
  },
  {
    key: 'resolutionId',
    xmlSelectors: [`${C029}/Assgnmt/Id`],
    labelKey: 'try.camt.fieldResolutionId',
    defKey: 'try.camt.defResolutionId',
    kind: 'text',
    expertOnly: true,
    simpleAlias: 'assignmentId',
  },
  {
    key: 'cxlStsId',
    xmlSelectors: [`${C029}/CxlDtls/TxInfAndSts/CxlStsId`],
    labelKey: 'try.camt.fieldCxlStsId',
    defKey: 'try.camt.defCxlStsId',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'outcome',
    xmlSelectors: [`${C029}/Sts/Conf`, `${C029}/CxlDtls/TxInfAndSts/TxCxlSts`],
    labelKey: 'try.camt.outcome',
    defKey: 'try.camt.outcomeDef',
    kind: 'select',
    options: ['ACCR', 'RJCR'],
  },
];

export const CAMT056_SIMPLE_SECTIONS: EditorSection[] = [
  { id: 'case', titleKey: 'try.camt.sectionCase', keys: ['assignmentId', 'caseId'], columns: 2 },
  { id: 'banks', titleKey: 'try.camt.sectionBanks', keys: ['assignorBic', 'assigneeBic'], columns: 2 },
  {
    id: 'original',
    titleKey: 'try.camt.sectionOriginal',
    keys: ['orgnlMsgId', 'orgnlEndToEndId', 'orgnlTxId'],
    columns: 2,
  },
  {
    id: 'money',
    titleKey: 'try.sectionMoney',
    keys: ['orgnlAmount', 'orgnlCurrency', 'orgnlSettlementDate'],
    columns: 2,
  },
  { id: 'reason', titleKey: 'try.camt.sectionReason', keys: ['cxlReason', 'addtlInf'] },
];

export const CAMT056_EXPERT_SECTIONS: EditorSection[] = [
  { id: 'document', titleKey: 'try.sectionDocument', keys: ['xmlns'] },
  {
    id: 'assignment',
    titleKey: 'try.camt.sectionAssignment',
    keys: ['assignmentId', 'caseId', 'createdAt', 'assignorBic', 'assigneeBic', 'resolutionId', 'cxlStsId'],
    columns: 2,
  },
  {
    id: 'original',
    titleKey: 'try.camt.sectionOriginal',
    keys: ['orgnlMsgId', 'orgnlMsgNmId', 'orgnlEndToEndId', 'orgnlTxId', 'orgnlAmount', 'orgnlCurrency', 'orgnlSettlementDate', 'cxlId'],
    columns: 2,
  },
  { id: 'reason', titleKey: 'try.camt.sectionReason', keys: ['cxlReason', 'addtlInf'] },
  { id: 'status', titleKey: 'try.camt.sectionResolution', keys: ['outcome'] },
];
